export interface SiteMonitoringState {
    sites: any
    loading: boolean
}

export const initialState: SiteMonitoringState = {
    sites: [],
    loading: false
};
